import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ApiService } from '../../../../../services/api.service';
import { FileUploadComponent } from '../../../../../common/file-upload/file-upload.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AutoCompleteCompleteEvent, AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { ActivatedRoute } from '@angular/router';
import { SelectButtonChangeEvent } from 'primeng/selectbutton';
import { Evento } from '../../../../../shared/interface';
import { CheckboxChangeEvent } from 'primeng/checkbox';

@Component({
  selector: 'app-add-personale-accrediti-backoffice',
  templateUrl: './add-personale-accrediti-backoffice.component.html',
  styleUrls: ['./add-personale-accrediti-backoffice.component.css']
})
export class AddPersonaleAccreditiBackofficeComponent {

  constructor(
    private apiService: ApiService,    
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {}

  @ViewChild('uploadCertificazioni', {static: false}) uploadCertificazioni!: FileUploadComponent;
  @ViewChild('uploadUnilav', {static: false}) uploadUnilav!: FileUploadComponent;

  @Input() visible: boolean = false;
  @Input() subappalto?: number;
  @Input() evento?: Evento;

  @Output() close = new EventEmitter<boolean>();

  categorie: { categoria: string; ruoli: { ruolo: string }[] }[] = [
    {
      categoria: 'Tecnico / Operativo',
      ruoli: [
        { ruolo: 'tecnico audio' },
        { ruolo: 'tecnico luci' },
        { ruolo: 'tecnico video' },
        { ruolo: 'macchinista' },
        { ruolo: 'facchino' },
        { ruolo: 'backliner' },
        { ruolo: 'rigger / lavori in quota' },
      ],
    },
    {
      categoria: 'Artistico',
      ruoli: [
        { ruolo: 'attore / attrice' },
        { ruolo: 'performer' },
        { ruolo: 'cantante' },
        { ruolo: 'musicista' },
      ],
    },
    {
      categoria: 'Produzione / Organizzazione',
      ruoli: [
        { ruolo: 'direzione di produzione' },
        { ruolo: 'assistente di produzione' },
        { ruolo: 'tour manager' },
        { ruolo: 'sarta / costumista' },
        { ruolo: 'make up Artist / parrucchiere' },        
        { ruolo: 'altro ruolo organizzativo' },
      ],
    },
    { categoria: 'Altro', ruoli: [] },
  ];
  categoria_filtrate: { categoria: string; ruoli: { ruolo: string }[] }[] = [];
  ruoli_filtrati: { ruolo: string }[] = [];
  tipologie: { tipologia: string }[] = [
    { tipologia: 'Dipendente della Compagnia / Ditta' },
    { tipologia: 'Lavoratore Autonomo con P.IVA' },
    { tipologia: 'Artista con agibilità INPS' },
    { tipologia: 'SubAppalto' },
    { tipologia: 'Altro' },
  ];
  presenze: { presenza: string }[] = [
    { presenza: 'Sempre' },
    { presenza: 'Montaggio' },
    { presenza: 'Prove' },
    { presenza: 'Spettacolo' },
    { presenza: 'Smontaggio' },
  ];
  presenze_filtrate: { presenza: string }[] = [];

  loading: boolean = false;  
  unilav: boolean = true;
  certificazioni: boolean = false;

  formPersonale!: FormGroup;

  ngOnInit(): void {
    this.formPersonale = new FormGroup({
      nome: new FormControl(null, Validators.required),
      cognome: new FormControl(null, Validators.required),
      categoria: new FormControl(null, Validators.required),
      ruolo: new FormControl({value:null, disabled: true}, Validators.required),
      tipologia: new FormControl(null, Validators.required),
      presenza: new FormControl(null, Validators.required),
      certificazioni: new FormControl([]),
      agibilita_inps: new FormControl(null),
      unilav: new FormControl([], Validators.required)
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.evento = changes['evento']?.currentValue || this.evento;
    this.subappalto = changes['subappalto']?.currentValue || this.subappalto;
  }

  onCategoria(categoria: { categoria: string } | null) {
    if (categoria && categoria?.categoria) {

      this.formPersonale.patchValue({ ruolo: null });
      this.formPersonale.get('ruolo')?.enable();
            
    } else {
      this.formPersonale.get('ruolo')?.disable();
    }
        
  }

  onFilterRuoli(event: AutoCompleteCompleteEvent) {
    this.ruoli_filtrati = [...this.formPersonale.get('categoria')?.value.ruoli].filter((ruolo) => ruolo.ruolo.toLowerCase().indexOf(event.query.toLowerCase()) == 0).length <= 0 ? [{ ruolo: event.query }] : [...this.formPersonale.get('categoria')?.value.ruoli].filter((ruolo) => ruolo.ruolo.toLowerCase().indexOf(event.query.toLowerCase()) == 0);
  }

  onRuolo(event: AutoCompleteSelectEvent) {
    if (event.value && event.value.ruolo == 'rigger / lavori in quota') {                  
      this.certificazioni = true;
      this.formPersonale.get('certificazioni')?.setValidators(Validators.required);        
    } else if (event.value && (event.value.ruolo == 'direzione di produzione' || event.value.ruolo == 'tour manager')) {                  
      this.unilav = false;
      this.formPersonale.get('unilav')?.removeValidators(Validators.required);      
    } else {
      this.certificazioni = false;            
      this.formPersonale.get('certificazioni')?.removeValidators(Validators.required);       
    }       

    this.formPersonale.get('certificazioni')?.updateValueAndValidity();
    this.formPersonale.get('unilav')?.updateValueAndValidity();
  }

  onFilterPresenze(event: AutoCompleteCompleteEvent) {
    this.presenze_filtrate = [...this.presenze].filter((presenza) => presenza.presenza.toLowerCase().indexOf(event.query.toLowerCase()) == 0).length <= 0 ? [{ presenza: event.query }] : [...this.presenze].filter((presenza) => presenza.presenza.toLowerCase().indexOf(event.query.toLowerCase()) == 0);
  }

  onTipologia(event: SelectButtonChangeEvent) {
    if (event.value && event.value.tipologia == 'Artista con agibilità INPS') {      
      this.formPersonale.get('agibilita_inps')?.setValidators(Validators.required);
    } else {
      this.formPersonale.get('agibilita_inps')?.removeValidators(Validators.required);
    }    
    this.formPersonale.get('agibilita_inps')?.updateValueAndValidity();
  }

  onAgibilita(event: CheckboxChangeEvent) {
    if (event.checked && event.checked.length > 0) {
      this.formPersonale.get('unilav')?.removeValidators(Validators.required);
      this.unilav = false;
    } else {
      if (this.formPersonale.get('ruolo')?.value && (this.formPersonale.get('ruolo')?.value.ruolo == 'direzione di produzione' || this.formPersonale.get('ruolo')?.value.ruolo == 'tour manager')) {
        this.formPersonale.get('unilav')?.removeValidators(Validators.required);
        this.unilav = false;
      } else {
        this.formPersonale.get('unilav')?.addValidators(Validators.required);
        this.unilav = true;
      }
    }    
    this.formPersonale.get('unilav')?.updateValueAndValidity();
  }

  onClose() {
    this.visible = false;
    this.close.emit(this.visible);
    this.cdr.detectChanges();
  }

  onAdd() {

    let persona = new FormData();

    persona.append("id_evento", (this.evento?.id || 0).toString());
    persona.append("nome", this.formPersonale.get('nome')?.value || '');
    persona.append("cognome", this.formPersonale.get('cognome')?.value || '');
    persona.append("categoria", this.formPersonale.get('categoria')?.value ? this.formPersonale.get('categoria')?.value.categoria : '');
    persona.append("ruolo", this.formPersonale.get('ruolo')?.value ? this.formPersonale.get('ruolo')?.value.ruolo : '');
    persona.append("tipologia", this.formPersonale.get('tipologia')?.value ? this.formPersonale.get('tipologia')?.value.tipologia: '');
    persona.append("presenza", (this.formPersonale.get('presenza')?.value|| []).map((presenza: {presenza: string}) => presenza.presenza).join(','));
    persona.append("agibilita_inps", this.formPersonale.get('agibilita_inps')?.value || '');
    persona.append("id_subappalto", ((this.subappalto || 0)?.toString()));
    (this.formPersonale.get('certificazioni')?.value || []).map((file: File) => persona.append("certificazioni", file || ''));
    (this.formPersonale.get('unilav')?.value || []).map((file: File) => persona.append("unilav", file || ''));
    
    this.apiService.addPersonale(persona).subscribe({
      next: (data) => {
        this.apiService.setPersonaleEvento(this.evento?.id!);
        this.apiService.setSubappaltiEvento(this.evento?.id!)
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {        
        this.uploadCertificazioni.clearUpload();
        this.uploadUnilav.clearUpload();

        this.formPersonale.reset();
        this.formPersonale.markAsUntouched();
        this.formPersonale.markAsPristine();    

        this.onClose()
      }
    });

  }

}
